import { createFeatureActionNamer } from '../redux/action-name';

const getActionName = createFeatureActionNamer('auth');

export const SET_ACTIVE_USER = getActionName('SET_ACTIVE_USER');
export const LOG_OUT = getActionName('LOG_OUT');
